import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import Scrollbar from '../../../Scrollbar';
// material
import {
    Table,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    TableContainer,
    Pagination,
    Box
} from '@mui/material';
import CommonTableHead from '../../../foodVendor/reports/commonTableHead.js';
import { getContractorSwipeHistoryWatcher } from '../../../../redux/actionCreators/admin/reports';
import SwipeHistoryTableRow from './tableRow';
import { useDispatch, useSelector } from 'react-redux';
import { getConvertedDate } from '../../../../utils/common';

export const TABLE_HEAD = [
    { id: 'contractorName ', label: 'Contractor Name ', alignRight: false, title: 'Contractor Name', field: 'Contractor Name' },
    { id: 'userName', label: 'User Name', alignRight: false, title: 'User Name', field: 'User Name' },
    { id: 'card', label: 'Card', alignRight: false, title: 'Card', field: 'Card' },
    { id: 'date', label: 'Date', alignRight: false, title: 'Date', field: 'Date' },
    { id: 'mealType', label: 'Meal Type', alignRight: false, title: 'Meal Type', field: 'MealType' },
    { id: 'deliveryCounter', label: 'Delivery Counter', alignRight: false, title: 'Delivery Counter', field: 'deliveryCounter' },
];


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
}

const SwipeHistoryTable = ({ searchVal, searchText, selectedMeal, fromDate = new Date(), toDate= new Date(), page, setPage }) => {

    const { ReportsReducers: { ContractorSwipeHistoryList } } = useSelector((state) => state)

    let firstIndex = 0;

    const dispatch = useDispatch();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [rowsPerPage] = useState(5);
    const tempinitsform = useRef();

    useEffect(() => {
        let data = {

            MealType: "Breakfast",
            SwipeDate: getConvertedDate(new Date()),
            SwipeDateTo: getConvertedDate(new Date())

        }
        dispatch(getContractorSwipeHistoryWatcher(data))
    }, [dispatch])

    const initsform = () => {
        let data = {
            MealType: selectedMeal,
            SwipeDate: getConvertedDate(fromDate),
            SwipeDateTo: getConvertedDate(toDate)
        }
        if (selectedMeal !== '') {
            dispatch(getContractorSwipeHistoryWatcher(data))
        }
    };
    
    tempinitsform.current = initsform;
    
    useEffect(() => {
       tempinitsform.current();
    }, [selectedMeal]);

    // useEffect(() => {
    //     let data = {
    //         MealType: selectedMeal,
    //         SwipeDate: getConvertedDate(fromDate),
    //         SwipeDateTo: getConvertedDate(toDate)
    //     }
    //     if (selectedMeal != '') {
    //         dispatch(getContractorSwipeHistoryWatcher(data))
    //     }
    // }, [selectedMeal])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const tableData = searchText.length ? searchVal : ContractorSwipeHistoryList
    const filteredData = applySortFilter(tableData, getComparator(order, orderBy));
    const isUserNotFound = filteredData?.length === 0;

    return (
        <>
            <Box>
                <Scrollbar>
                    <TableContainer sx={{overflow:'unset'}} >
                        <Table>
                            <CommonTableHead
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD}
                                //   rowCount={USERLIST.length}
                                //   numSelected={selected.length}
                                onRequestSort={handleRequestSort}
                            />
                            <TableBody>
                                {filteredData?.slice(firstIndex + rowsPerPage * (page - 1), rowsPerPage * page)
                                    .map((m, i) => {
                                        return (
                                            <SwipeHistoryTableRow key={m.Card} rowData={m} index={i} />
                                        )
                                    })}
                            </TableBody>
                            {isUserNotFound && (
                                <TableBody>
                                    <TableRow display='flex'>
                                        <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                                            <Typography variant='t18_500' >
                                                No records found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Scrollbar>
            </Box>
            <Box spacing={2} display='flex' justifyContent='right' paddingTop='20px' >
                <Pagination
                    shape="rounded"
                    color='primary'
                    count={Math.ceil(tableData?.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage}
                />
            </Box>
        </>
    )
}

export default SwipeHistoryTable;